.rootLabel {
  margin-right: 8px;
}

.buttonGroupWrap {
  flex-wrap: wrap;
  flex: 1;
}

.noteButton {
  text-transform: none;
  padding: 0;
}

.noneButton {
  text-transform: none;
  padding: 0;
  padding-left: 8px;
  padding-right: 8px;
}

.rootRow {
  margin-top: 8px;
  gap: 16px;
  display: flex;
}

.scaleTypeSelect {
  min-width: 200px;
  position: relative;
}
